import React from 'react'
import './services.css';

function Services () {

  return (
  <div className='services-container'>
    <div className='services-bg'>
      <div className='services-title'>Our Services</div>
      <div className='services-items'>
        <div className='services-items-list'>
          <div className='services-item-icon-box'>
            <img src="services-image.png" alt="item-icon" className='services-item-icon'></img>
          </div>
          <div className='services-item-title'>
          Social Media Marketing
          </div>
        </div>
        <div className='services-items-list'>
          <div className='services-item-icon-box'>
            <img src="services-image.png" alt="item-icon" className='services-item-icon'></img>
          </div>
          <div className='services-item-title'>
            Truck Design
          </div>
        </div>
        <div className='services-items-list'>
          <div className='services-item-icon-box'>
            <img src="services-image.png" alt="item-icon" className='services-item-icon'></img>
          </div>
          <div className='services-item-title'>
            Logo Design
          </div>
        </div>
        <div className='services-items-list'>
          <div className='services-item-icon-box'>
            <img src="services-image.png" alt="item-icon" className='services-item-icon'></img>
          </div>
          <div className='services-item-title'>
            Page Layout Design
          </div>
        </div>
        <div className='services-items-list'>
          <div className='services-item-icon-box'>
            <img src="services-image.png" alt="item-icon" className='services-item-icon'></img>
          </div>
          <div className='services-item-title'>
            Name Board Design
          </div>
        </div>
        <div className='services-items-list'>
          <div className='services-item-icon-box'>
            <img src="services-image.png" alt="item-icon" className='services-item-icon'></img>
          </div>
          <div className='services-item-title'>
            Poster Design
          </div>
        </div>
        <div className='services-items-list'>
          <div className='services-item-icon-box'>
            <img src="services-image.png" alt="item-icon" className='services-item-icon'></img>
          </div>
          <div className='services-item-title'>
            Magazine Layout
          </div>
        </div>
        <div className='services-items-list'>
          <div className='services-item-icon-box'>
            <img src="services-image.png" alt="item-icon" className='services-item-icon'></img>
          </div>
          <div className='services-item-title'>
            Menu Cards
          </div>
        </div>
        <div className='services-items-list'>
          <div className='services-item-icon-box'>
            <img src="services-image.png" alt="item-icon" className='services-item-icon'></img>
          </div>
          <div className='services-item-title'>
            Business Cards
          </div>
        </div>
        <div className='services-items-list'>
          <div className='services-item-icon-box'>
            <img src="services-image.png" alt="item-icon" className='services-item-icon'></img>
          </div>
          <div className='services-item-title'>
            Wedding Card Design
          </div>
        </div>
        <div className='services-items-list'>
          <div className='services-item-icon-box'>
            <img src="services-image.png" alt="item-icon" className='services-item-icon'></img>
          </div>
          <div className='services-item-title'>
            Brochures
          </div>
        </div>
        <div className='services-items-list'>
          <div className='services-item-icon-box'>
            <img src="services-image.png" alt="item-icon" className='services-item-icon'></img>
          </div>
          <div className='services-item-title'>
            Portfolio Creation
          </div>
        </div>
        <div className='services-items-list'>
          <div className='services-item-icon-box'>
            <img src="services-image.png" alt="item-icon" className='services-item-icon'></img>
          </div>
          <div className='services-item-title'>
            Greeting Cards
          </div>
        </div>
        <div className='services-items-list'>
          <div className='services-item-icon-box'>
            <img src="services-image.png" alt="item-icon" className='services-item-icon'></img>
          </div>
          <div className='services-item-title'>
            Banner Design
          </div>
        </div>
        <div className='services-items-list'>
          <div className='services-item-icon-box'>
            <img src="services-image.png" alt="item-icon" className='services-item-icon'></img>
          </div>
          <div className='services-item-title'>
            Products Package Design
          </div>
        </div>
        <div className='services-items-list'>
          <div className='services-item-icon-box'>
            <img src="services-image.png" alt="item-icon" className='services-item-icon'></img>
          </div>
          <div className='services-item-title'>
            Sticker Design
          </div>
        </div>
        <div className='services-items-list'>
          <div className='services-item-icon-box'>
            <img src="services-image.png" alt="item-icon" className='services-item-icon'></img>
          </div>
          <div className='services-item-title'>
            Big Hoarding Flex Design
          </div>
        </div>
        <div className='services-items-list'>
          <div className='services-item-icon-box'>
            <img src="services-image.png" alt="item-icon" className='services-item-icon'></img>
          </div>
          <div className='services-item-title'>
            News Paper Page Design
          </div>
        </div>
      </div>
    </div>
   
  </div>
    

  
);
}

export default Services;
